import React from "react";
import { formatCurrency } from "../../../common/helpers/currencyHelper";
import { CheckIcon, UnCheckIcon } from "../Elements";



const InstallmentList =({installmentList, selectedInstallment, setSelected })=>{


    function isSelectedInstallment(item) {

        return selectedInstallment == item.month;
      }

    return installmentList.map((item, index) => {

        const isSelected = isSelectedInstallment(item);
        return (
          <div  className={`cursor-pointer installment-item ${index == 0 ? "installment-item-first" : ""}`} key={index}
            onClick={() => {
              setSelected(item); 
            }}
          >
            <div className="flex-container direction-row align-items-center cursor-pointer ">
              {isSelected ? <CheckIcon /> : <UnCheckIcon />}{"  "}
              <label className={`px2 cursor-pointer ${isSelected ? "Text-fontWeight--700" : ""}`}>
                {item.month == 1 ? "Tek Çekim" : (item.month + " x " + formatCurrency(item.monthlyAmount))}
              </label>
            </div>
            <div className={`cursor-pointer ${isSelected ? "Text-fontWeight--700" : ""}`}>
              ₺ {formatCurrency(item.totalAmount)}
            </div>
          </div>
        );
      })
}
export default InstallmentList;